import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=4cb6f2b3&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=4cb6f2b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb6f2b3",
  null
  
)

component.options.__file = "Profile.vue"
export default component.exports